.CommandPaletteFilters {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    border-bottom: 1px solid var(--soniq-t--global--border--color--card--default);
    flex-wrap: wrap;
}

.CommandPaletteFilters__pill {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 999px;
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    background: transparent;
    color: var(--soniq-t--global--text--color--label--default);
    font-size: var(--soniq-t--global--font--size--date);
    font-family: var(--soniq-t--global--font--family--sans);
    font-weight: var(--soniq-t--global--font--weight--medium);
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
    line-height: 1.4;

    &:hover:not(.isActive) {
        background: var(--soniq-t--global--background--color--surface--hover);
    }

    &.isActive {
        background: var(--soniq-t--global--background--color--accent--active--default);
        border-color: var(--soniq-t--global--border--color--accent--active--default);
        color: rgba(240, 71, 112, 0.9);
    }
}
